import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';

export const MicrosoftSignInFieldSchema = makeFieldSchema({
  output: z => z.string(),
  uiOptions: z =>
    z.object({
      additionalScopes: z
        .array(z.string())
        .optional()
        .describe('Additional Microsoft API scopes to request during sign-in'),
      requestUserCredentials: z
        .object({
          secretsKey: z
            .string()
            .describe(
              'Key used within the template secrets context to store the credential',
            ),
        })
        .describe('User credential to auth the Azure access'),
    }),
});

export type MicrosoftSignInProps = typeof MicrosoftSignInFieldSchema.TProps;
